const tweetIds = [
  '1243675836860862465',
  '1306209006487318528',
  '1304511569091387392',
  '995136157703798784',
  '1124432562657603585',
  '1131770397894955008',
  '1055229824149540864',
  '605791121071968256',
  '1131743325386502144',
  '1129528115779125248',
  '1294033347417538560',
  '1129561886234570752',
  '1128824042297995265',
  '938881664457039872',
  '1123695004160069634',
  '589508337428877313',
  '1121163510736662528',
  '1126863259800199170',
  '1121893507965366272',
  '1294383000017350659',
  '1126339571568992256',
  '1121567310697893894',
  '1120872210086924293',
  '1121885985741127681',
  '1050534095598567426',
  '1128788961357381634',
  '1126196691613302784',
  '1123738709478780929',
  '1124807564854738944',
  '1124466196286517250',
  '1124429190575677440',
  '1124444649563852800',
  '1124430866493603841',
  '1124013006730428416',
  '1122923811115028486',
  '1130980438082695169',
]

const distinctTweetIds = [...new Set(tweetIds)]
export default distinctTweetIds

const counts = {}
tweetIds.forEach((t) => (counts[t] = (counts[t] || 0) + 1))
for (let i in counts) {
  if (counts[i] > 1) {
    console.error(`TweetID ${i} is found ${counts[i]} times`)
  }
}
